import moment from 'moment';
import 'moment/locale/pt-br';

moment.locale('pt-br');

const useMoment = () => {
  const formatDateTimeSend = (date: string | Date) => {
    const newDate = moment(date).utc().format('YYYY-MM-DDTHH:mm:ss');
    return newDate;
  };

  const formatDate = (date: string | Date) => {
    const newDate = moment(date).format('DD/MM/YYYY');
    return newDate;
  };

  const formatDateIfen = (date: string | Date) => {
    const newDate = moment(date).format('YYYY-MM-DD');
    return newDate;
  };

  const formatTime = (date: string | Date) => {
    const newDate = moment(date).format('HH:mm');
    return newDate;
  };

  const getWeekday = (date: string | Date) => {
    const newDate = moment.weekdays(moment(date).day());
    return newDate;
  };

  const isSameDay = (date1: Date, date2: Date) => {
    return moment(date1).isSame(date2, 'day');
  };

  const momentFn = moment;

  return { momentFn, formatDateTimeSend, formatDate, formatDateIfen, formatTime, getWeekday, isSameDay };
};

export default useMoment;
